import React, { useState } from 'react';
import 'remixicon/fonts/remixicon.css';
import { useDispatch } from 'react-redux';
import {setWatchOffCanvasIsActive, toggleFaveWatchOffCanvasIsActive} from '../../../../Features/Misc/navBarSlice';
import { setActiveWatch } from '../../../../Features/Misc/activeSlice';
import { Animate } from 'react-simple-animate';
import stripHtml from '../../../Components/StripHTML';
import FaveHeart from '../../../Components/FaveHeart';

import defaultSleepImage1 from "../../../../assets/default-images/default-sleep-image-1.png"
import defaultSleepImage2 from '../../../../assets/default-images/default-sleep-image-2.png';
import defaultSleepImage3 from '../../../../assets/default-images/default-sleep-image-3.png';
import defaultSleepImage4 from '../../../../assets/default-images/default-sleep-image-4.png';
import defaultSleepImage6 from '../../../../assets/default-images/default-sleep-image-6.jpg';
import defaultSleepImage7 from '../../../../assets/default-images/default-sleep-image-7.jpg';
import defaultSleepImage8 from '../../../../assets/default-images/default-sleep-image-8.jpg';
import defaultSleepImage9 from '../../../../assets/default-images/default-sleep-image-9.jpg';
import defaultSleepImage10 from '../../../../assets/default-images/default-sleep-image-10.jpg';

const FaveWatchCard = React.memo((props) => {
    const [toggleFade, setToggleFade] = useState(false);

    const {
        imgSrc,
        title,
        text,
        vidLink,
        mediaType,
        mediaId,
        orientation
    } = props

    const dispatch = useDispatch();

    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10,
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);

    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];
    // console.log(imageUrl && imageUrl)

    const watchPayload = React.useMemo(() => ( {
        imgSrc,
        title,
        text,
        vidLink,
        mediaType,
        mediaId,
        orientation

    }), [imgSrc, title, text, vidLink, mediaType, mediaId]);

    const handleCardClick = React.useCallback(() => {
        dispatch(toggleFaveWatchOffCanvasIsActive());
        dispatch(setActiveWatch(watchPayload));
    }, [dispatch, watchPayload]);


    return (
        <div className={`faveWatchCard_gapper pr-6 h-96 m:h-104 3xl:h-116 cursor-pointer hover:opacity-60 transition-opacity duration-300` } onClick={handleCardClick}>
            <Animate
                play={toggleFade}
                start={{
                    opacity: 1,
                    borderWidth: '3px',
                    display: 'grid',
                    borderColor: '#8E6E8A',
                    borderRadius: '0.5rem',
                    color: 'rgb(255 255 255)',
                    padding: '1rem',
                    height: '100%',
                    gridTemplateRows: 'repeat(24, minmax(0, 1fr))',
                }}
                end={{
                    opacity: 0,
                    borderWidth: '3px',
                    display: 'grid',
                    borderColor: '#8E6E8A',
                    borderRadius: '0.5rem',
                    color: 'rgb(255 255 255)',
                    padding: '1rem',
                    height: '100%',
                    gridTemplateRows: 'repeat(24, minmax(0, 1fr))',
                }}
                duration={0.1}
            >
                <div
                    className="faveWatchCard_image h-52 3xl:h-56 w-full bg-white rounded-lg bg-cover no-repeat bg-center row-start-1 row-end-13 grid grid-rows-12 grid-cols-24 cursor-pointer"
                    style={{ backgroundImage: `url(${imageUrl})` }}
                >
                    <FaveHeart type={'Watch'} mediaId={mediaId} mediaType={mediaType} fadeFunction={() => setToggleFade(!toggleFade)} />
                </div>
                <div className="faveWatchCard_title text-lg 3xl:text-xl row-start-16 row-end-18 3xl:row-start-14 3xl:row-end-17 truncate">{stripHtml(title)}</div>
                <div className="faveWatchCard_text text-xs 3xl:text-sm row-start-18 row-end-22 3xl:row-start-17 ">{stripHtml(text.substring(0, 150))}...</div>
                <div className="faveWatchCard_button bg-purple-dashboard flex flex-row items-center  text-sm 3xl:text-base row-start-24 row-end-25">
                    <button  onClick={() => {dispatch(toggleFaveWatchOffCanvasIsActive()); dispatch(setActiveWatch(watchPayload)) }}  className='flex flex-row items-center cursor-pointer '>Watch Now </button>
                    <i className="text-gold-accent ri-arrow-right-line ml-2" />
                </div>
            </Animate>
        </div>
    );
});

export default FaveWatchCard